var exports = {
  "wx": "GuildHeaderBottomSheet.module__header___eUlMRm",
  "R3": "GuildHeaderBottomSheet.module__avatarWrapper___eUlMRm",
  "Kk": "GuildHeaderBottomSheet.module__icon___eUlMRm",
  "Qq": "GuildHeaderBottomSheet.module__text___eUlMRm",
  "DD": "GuildHeaderBottomSheet.module__title___eUlMRm",
  "M1": "GuildHeaderBottomSheet.module__stats___eUlMRm",
  "dJ": "GuildHeaderBottomSheet.module__stat___eUlMRm",
  "gW": "GuildHeaderBottomSheet.module__statDot___eUlMRm",
  "rR": "GuildHeaderBottomSheet.module__statDotOnline___eUlMRm",
  "rb": "GuildHeaderBottomSheet.module__statDotMembers___eUlMRm",
  "KA": "GuildHeaderBottomSheet.module__statText___eUlMRm",
};

module.exports = exports;
